

















import { Component, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'
import Account from './AccountComponents/Account'
import Banking from './AccountComponents/Banking'
import History from './AccountComponents/History'
import { setCheckoutTheme } from '@/utils/gamblingHelpers'

@Component({
  components: {
    Account,
    Banking,
    History
  },
  computed: {
    ...mapState({
      username: ({ gamblingContext }: any): null | string => gamblingContext.credentials.username,
      email: ({ gamblingContext }: any): null | string => gamblingContext.credentials.email,
      accountType: ({ gamblingContext }: any): string => gamblingContext.accountType
    })
  }
})

export default class AccountContent extends Vue {
  created () {
    const theme = document.querySelector('#gambling-checkout-vars')
    const darkTheme = theme && theme.innerHTML.includes('checkout-theme:dark')
    if (darkTheme) {
      setCheckoutTheme('dark')
    } else {
      setCheckoutTheme('light')
    }
  }
}
